import React from 'react';

import styles from './ContentListDetailSwitch.module.scss';

type Props = {
  isDetailPagePreview: boolean;
  setIsDetailPagePreview: (arg: boolean) => void;
};

const ContentListDetailSwitch: React.FC<Props> = ({ isDetailPagePreview, setIsDetailPagePreview }) => (
  <ul className={styles.list}>
    <li className={styles.list__item}>
      <button
        type='button'
        className={`${styles.button} ${!isDetailPagePreview ? styles.button_active : ''}`}
        onClick={() => setIsDetailPagePreview(false)}
        disabled={!isDetailPagePreview}
      >
        一覧
      </button>
    </li>
    <li className={styles.list__item}>
      <button
        type='button'
        className={`${styles.button} ${isDetailPagePreview ? styles.button_active : ''}`}
        onClick={() => setIsDetailPagePreview(true)}
        disabled={isDetailPagePreview}
      >
        詳細
      </button>
    </li>
  </ul>
);

export default ContentListDetailSwitch;
